/**
 * SEO 配置 - chat (简体中文)
 */

export default {
    chat: {
        title: 'AI 对话 - 多模型智能助手 | WeryAI',
        description:
            '在 WeryAI 与多个顶尖 AI 模型同时对话，支持多窗口并排对比回复。一站式生成图片、视频和音乐，开启高效 AI 创作体验。免费使用，无需切换平台。',
        keywords:
            'AI 对话, AI 聊天, 多模型对话, AI 助手, 智能助手, 并排对比 AI, AI 工作台, 免费 AI 聊天, WeryAI',
        og_title: 'AI 对话 - 多模型智能助手 | WeryAI',
        og_description:
            '与多个顶尖 AI 模型同时对话，多窗口并排对比。一站式生成图片、视频和音乐。免费体验 WeryAI。',
        twitter_title: 'AI 对话 - 多模型智能助手 | WeryAI',
        twitter_description:
            '与多个顶尖 AI 模型同时对话，多窗口并排对比。一站式生成图片、视频和音乐。免费体验 WeryAI。',
    },
}
